export class NewsAlertsEnvironment {
  public static getName = () => 'benzinga-news-alerts';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://api.benzinga.com/'),
  });
}
